import { render, staticRenderFns } from "./logo-primary.vue?vue&type=template&id=3503a667&scoped=true"
import script from "./logo-primary.vue?vue&type=script&lang=js"
export * from "./logo-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503a667",
  null
  
)

export default component.exports